interface CalendarSchedulingBannerProps {
  isSchedulingMode: boolean;
  isRescheduleMode: boolean;
  reschedulingSessionInfo: { patientName: string; date: string } | null;
  schedulingPatientName?: string;
  onCancel: () => void;
}

export const CalendarSchedulingBanner = ({
  isSchedulingMode,
  isRescheduleMode,
  reschedulingSessionInfo,
  schedulingPatientName,
  onCancel,
}: CalendarSchedulingBannerProps) => {
  if (!isSchedulingMode && !isRescheduleMode) return null;

  return (
    <>
      <div
        style={{
          background: "linear-gradient(135deg, #6D57BC 0%, #8b5cf6 100%)",
          color: "#fff",
          padding: "1rem 1.5rem",
          borderRadius: "12px",
          marginBottom: "1rem",
          fontSize: "0.95rem",
          fontWeight: 700,
          boxShadow: "0 4px 12px rgba(109, 87, 188, 0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "1rem",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          <span style={isRescheduleMode ? { fontWeight: 500, fontSize: "0.8125rem" } : undefined}>
            {isRescheduleMode && reschedulingSessionInfo ? (
              <>
                Reprogramando sesión de {reschedulingSessionInfo.patientName} del{" "}
                {reschedulingSessionInfo.date}. Seleccioná un nuevo horario.
              </>
            ) : schedulingPatientName ? (
              <>
                Seleccione un horario disponible en el calendario para programar la sesión con{" "}
                <strong>{schedulingPatientName}</strong>
              </>
            ) : (
              "Seleccione un horario disponible en el calendario para programar la sesión"
            )}
          </span>
        </div>
        <button
          type="button"
          aria-label="cancel-scheduling"
          onClick={onCancel}
          style={{
            display: "inline-flex",
            alignItems: "center",
            border: "2px solid #fff",
            borderRadius: "9999px",
            padding: "0.5rem 1rem",
            background: "transparent",
            color: "#fff",
            fontWeight: 700,
            height: "35px",
            cursor: "pointer",
            transition: "all 0.2s ease-out",
            whiteSpace: "nowrap",
          }}
          onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
        >
          Cancelar
        </button>
      </div>
    </>
  );
};
